import { Axios } from 'utils/AxiosConfig'

export const postForgotPassword = async (payload) => {
  const { data: response } = await Axios.post(`forgot-password`, payload)
  return response
}
